const END_OF_COHORT_YEAR_MONTH = 7;

export const getCommitBeforeDec31Date = (today: Date) => {
  const year =
    today.getMonth() <= END_OF_COHORT_YEAR_MONTH - 1
      ? today.getFullYear() - 1
      : today.getFullYear();

  return new Date(year, 11, 31);
};
